import configFile from './config.json';
import { CommonConfigInterface, DomainConfigInterface } from './types';

interface ConfigInterface {
    [key: string]: DomainConfigInterface | CommonConfigInterface;
}

const get = (
    key: string
): DomainConfigInterface | CommonConfigInterface | undefined => {
    return configFile.hasOwnProperty(key)
        ? (configFile as ConfigInterface)[key]
        : undefined;
};

export default { get };
